import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { whatsappLink } from "@/lib/billing";
import { LogoMark } from "@/components/app/Logo";
import { LandingNav } from "@/components/landing/LandingNav";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks, Features } from "@/components/landing/Features";
import { Pricing } from "@/components/landing/Pricing";
import { LeadForm } from "@/components/landing/LeadForm";

export default function Landing() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/public/info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  const wa = info?.whatsapp ? whatsappLink(info.whatsapp, "Olá! Quero conhecer o Ciclo Certo.") : null;

  return (
    <div className="app-grain min-h-screen scroll-smooth" data-testid="landing-page">
      <LandingNav />
      <Hero info={info} />
      <HowItWorks />
      <Features />
      <Pricing info={info} />
      <LeadForm />
      <footer className="border-t border-slate-800 py-8">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-4 text-sm text-slate-500 sm:px-6">
          <span className="flex items-center gap-2"><LogoMark className="h-5 w-5" /> © {new Date().getFullYear()} Ciclo Certo</span>
          {wa && <a href={wa} target="_blank" rel="noreferrer" className="hover:text-slate-300" data-testid="footer-whatsapp-link">WhatsApp</a>}
        </div>
      </footer>
      {wa && (
        <a href={wa} target="_blank" rel="noreferrer" aria-label="Falar no WhatsApp" data-testid="whatsapp-fab"
          className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-slate-950 shadow-2xl transition-transform duration-200 hover:scale-110">
          <MessageCircle className="h-6 w-6" />
        </a>
      )}
    </div>
  );
}
